import {point as pointFN} from "@turf/helpers";

export default function turfPoint(coordinates, properties, options) {
    return pointFN(coordinates, properties, options);
}
